require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./en-us-project-aiib-colombo-urban-regeneration-project.json") })
        }
      }, "path---en-us-project-aiib-colombo-urban-regeneration-project");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---en-us-project-aiib-colombo-urban-regeneration-project!./.cache/json/en-us-project-aiib-colombo-urban-regeneration-project.json
// module id = 489
// module chunks = 231608221292675